/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_DescriptionInputs */

const en_admin_users_description = /** @type {(inputs: Admin_Users_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage all registered users`)
};

const zh_admin_users_description = /** @type {(inputs: Admin_Users_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理所有注册用户`)
};

/**
* | output |
* | --- |
* | "Manage all registered users" |
*
* @param {Admin_Users_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_description = /** @type {((inputs?: Admin_Users_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_description(inputs)
	return zh_admin_users_description(inputs)
});
export { admin_users_description as "admin.users.description" }